/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { FormattedMessage } from '@modules/i18n'
import type { RoutableBreadcrumb } from '@modules/ui-types'
import type { ProjectType } from '@modules/ui-types/projects'
import { getPrettyProjectType } from '@modules/project-lib/display'

import { projectTypeCreationUrl, resourceCreationManagedUrl } from './urls'

export const solutionCreationCrumbs = (): RoutableBreadcrumb[] => [
  {
    to: resourceCreationManagedUrl(),
    text: (
      <FormattedMessage
        id='crumb-builder.resource-creation-crumbs'
        defaultMessage='Create serverless project'
      />
    ),
  },
]

export const projectCreationCrumbs = (projectType: ProjectType): RoutableBreadcrumb[] => [
  ...solutionCreationCrumbs(),
  {
    to: projectTypeCreationUrl(projectType),
    text: <FormattedMessage {...getPrettyProjectType(projectType)} />,
  },
]
